import React, { useState } from 'react';
import './Navigation.scss';
import { ModalPopup } from '../../CommonComponent';

const Navigation = (props: any) => {
    const { headerNav, onToggleHeaderMenu, guestUserUrlLink} = props;
    const [distribuotrLocatorDialogVisible, setDistribuotrLocatorDialogVisible] = useState<boolean>(false);
    const toggleDialog = () => {
        setDistribuotrLocatorDialogVisible(!distribuotrLocatorDialogVisible);
    }

    return (
        <>
        <div className="navigation-wrapper">
            <span
                className='fa fa-bars menuBars'
                onClick={() => onToggleHeaderMenu()}
                onKeyDown={() => { }}
            />
            {(headerNav &&
                <nav className='headerNavigation'>
                    <ul>
                        <li>
                            <a href={guestUserUrlLink?.aboutMykomatsuUrl} target="_blank">About My Komatsu</a>
                        </li>
                        <li>
                            <a href={guestUserUrlLink?.mvcGuestUserPartStoreUrl}>Parts Store</a>
                        </li>
                        <li>
                            <a href={guestUserUrlLink?.smartConstructionUrl} target="_blank">Smart Construction</a>
                        </li>
                    </ul>
                    <ul className='locateDistributor'>
                            <li>
                                <a href="#" onClick={toggleDialog}>Locate a Distributor</a>
                            </li>
                    </ul>
                </nav>
            )}

          <div className='clear-both' />
        </div>

        {
            distribuotrLocatorDialogVisible && (
                 <ModalPopup
                    ModalPopupTitle="Find Your Distributor"
                    ModalPopupType="Xl"
                    closeModalPopup={toggleDialog}>
                    <div className='row'>
                            <div className='col-12'>
                                <iframe src={guestUserUrlLink?.distributorLocateUrl} width="100%" height="411" allowFullScreen={true} title="Find Your Distributor"></iframe>
                            </div>
                    </div>
                </ModalPopup>
                )}
        </>
    );
};

export default Navigation;